/* Colour photographs: native scrolling; never changes product selection or destinations. */
(() => {
  'use strict';
  if (window.ogColourCarouselLoaded) return;
  window.ogColourCarouselLoaded = true;
  const selector = '.oh-th__swatches, .color-siblings__swatches, .oh-pdp-b .variants__list';
  const instances = new Map();
  const locale = (document.documentElement.lang || 'es').split('-')[0];
  const copy = {
    es: ['Colores anteriores', 'Más colores'], en: ['Previous colours', 'More colours'],
    fr: ['Couleurs précédentes', 'Plus de couleurs'], de: ['Vorherige Farben', 'Weitere Farben'],
    ru: ['Предыдущие цвета', 'Другие цвета'], zh: ['上一组颜色', '更多颜色']
  }[locale] || ['Previous colours', 'More colours'];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let serial = 0;

  function enhance(track) {
    if (instances.has(track)) return;
    const parent = track.parentElement;
    const label = track.previousElementSibling;
    if (!parent || !label) return;
    const abort = new AbortController();
    const signal = abort.signal;
    let frame = 0;
    let revealed = false;
    track.id ||= `og-colour-track-${++serial}`;
    track.classList.add('og-colour-track');
    parent.classList.add('og-colour-carousel');
    const header = document.createElement('div');
    header.className = 'og-colour-carousel__header';
    label.before(header);
    header.append(label);
    const controls = document.createElement('div');
    controls.className = 'og-colour-carousel__controls';
    controls.hidden = true;
    const buttons = copy.map((text, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'og-colour-carousel__arrow';
      button.setAttribute('aria-label', text);
      button.setAttribute('aria-controls', track.id);
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', index ? 'm9 5 7 7-7 7' : 'm15 5-7 7 7 7');
      svg.append(path);
      button.append(svg);
      controls.append(button);
      return button;
    });
    header.append(controls);
    const cells = () => Array.from(track.children).filter(el => el.matches('a, button, label') && !el.hidden);
    const rtl = () => getComputedStyle(track).direction === 'rtl';
    const behavior = () => reduceMotion.matches ? 'auto' : 'smooth';

    function reveal(cell, smooth) {
      const box = track.getBoundingClientRect();
      const item = cell.getBoundingClientRect();
      const delta = item.left < box.left + 4 ? item.left - box.left - 4 :
        item.right > box.right - 4 ? item.right - box.right + 4 : 0;
      if (delta) track.scrollBy({left: delta, behavior: smooth ? behavior() : 'auto'});
    }
    function update() {
      frame = 0;
      const items = cells();
      const box = track.getBoundingClientRect();
      const overflows = items.length > 1 && track.scrollWidth > track.clientWidth + 2;
      controls.hidden = !overflows;
      buttons.forEach(button => { button.style.transform = rtl() ? 'scaleX(-1)' : ''; });
      if (!items.length || !box.width) return;
      if (!revealed) {
        const current = track.querySelector('[aria-current], .is-active, .is-current');
        if (current) reveal(current, false);
        revealed = true;
      }
      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();
      buttons[0].disabled = !overflows || (rtl() ? first.right <= box.right + 1 : first.left >= box.left - 1);
      buttons[1].disabled = !overflows || (rtl() ? last.left >= box.left - 1 : last.right <= box.right + 1);
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const items = cells();
        if (!items.length) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = items[0].getBoundingClientRect().width + gap;
        const distance = Math.max(step, Math.floor(track.clientWidth / step) * step);
        track.scrollBy({left: distance * (index ? 1 : -1) * (rtl() ? -1 : 1), behavior: behavior()});
      }, {signal});
    });
    track.addEventListener('scroll', schedule, {passive: true, signal});
    track.addEventListener('focusin', event => {
      const cell = event.target.closest('a, button, label');
      if (cell && track.contains(cell)) reveal(cell, false);
    }, {signal});
    track.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      const items = cells();
      const index = items.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      let next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 :
        index + (event.key === 'ArrowRight' ? 1 : -1) * (rtl() ? -1 : 1);
      next = Math.max(0, Math.min(items.length - 1, next));
      event.preventDefault();
      items[next].focus({preventScroll: true});
      reveal(items[next], false);
    }, {signal});
    const resize = new ResizeObserver(schedule);
    resize.observe(track);
    const mutation = new MutationObserver(schedule);
    mutation.observe(track, {childList: true});
    instances.set(track, () => {
      abort.abort(); resize.disconnect(); mutation.disconnect(); cancelAnimationFrame(frame);
    });
    schedule();
  }
  function scan(root) {
    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll(selector).forEach(enhance);
  }
  function start() {
    const main = document.getElementById('main');
    if (!main) return;
    scan(main);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
      }
      for (const [track, dispose] of instances) {
        if (!track.isConnected) { dispose(); instances.delete(track); }
      }
    }).observe(main, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
